module.exports = require('lodash').bind